import { Merchandise } from '@questwork/q-store-model'

const updateAllowedProps = []

class MerchandiseEvent extends Merchandise {
  constructor(options = {}) {
    options = options || {}
    super(options)
    this.merchandiseType = 'MerchandiseEvent'
    this.eventShortCode = options.eventShortCode
  }

  // class method
  static dummyData() {
    return {
      ...Merchandise.dummyData(),
      merchandiseType: 'MerchandiseEvent',
      eventShortCode: 'demo2017',
    }
  }
  static init(options = {}) {
    const merchandiseEvent = new MerchandiseEvent(options)
    return merchandiseEvent.isValid ? merchandiseEvent : null
  }

  // getters
  get isValid() {
    return super.isValid && this.eventShortCode
  }

  toToolkit({ dateTime } = {}) {
    // const timestamp = dateTime || Date.now()
    // const prices = this.getPricesByTime(timestamp) || []
    this.prices.sort((a, b) => a.dateBegin - b.dateBegin)
    this.prices = this.prices.map((p) => {
      const { priceStrategies = [] } = p
      priceStrategies.forEach((ps) => {
        const { remarks = [] } = ps
        ps.remarks = remarks.filter((r) => r.key !== 'restrictions')
      })
      return p
    })
  }

  updateMerchandise(update) {
    Object.keys(update).forEach((key) => {
      if (updateAllowedProps.includes(key)) {
        this[key] = update[key]
      }
    })
    return super.updateMerchandise(update)
  }
}

export default {
  MerchandiseEvent
}
export {
  MerchandiseEvent
}
